import { getBrowser, getDevice, SOCIAL_TYPES } from "./services/utility";
import { Alert } from "./services/components";
import { DEFAULT_SELF_SERVE_TRIAL_TYPE } from "./signupPlans";

let isLoginCall = false;

const HOST_URL = (typeof window !== "undefined" && window.__IS_WHITELABEL__) ? window.location.origin : process.env.HOST_URL;
function service(param, isTeamLogin) {
  const data = param;
  data.appInfo = {};
  data.appInfo.APP_TYPE = "APP";
  data.appInfo.BROWSER_TYPE = getBrowser();
  data.appInfo.DEVICE_TYPE = getDevice();
  if (data.package) {
    data.trialType = data.package;
  }
  if (isTeamLogin) {
    data.isTeamLogin = isTeamLogin;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("inviteToken");
  const redirectUrl = urlParams.get("redirectUrl");
  if (token) {
    data.teamInviteToken = token;
  }
  if (redirectUrl) {
    data.redirectUrl = redirectUrl;
  }

  return $.ajax({
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: `${HOST_URL}/auth/login`,
    data: JSON.stringify(data),
  });
}
function success(status, response) {
  if (!status) {
    if (response.status) {
      window.location.href = response.data.redirectOauthUrl;
    }
  }
}
function fail(error) {
  console.error(error);
}
function login(
  networkType,
  reAuthenticate,
  productType,
  type,
  couponCode,
  lifetimeCode,
  isTeamLogin,
) {
  const loginObj = {};

  if (reAuthenticate) {
    loginObj.force = true;
  }

  if (networkType === "facebook") {
    loginObj.scope = "photos,publish,email";
  } else if (networkType === "windows") {
    loginObj.scope = "wl.signin,wl.basic,wl.emails";
  } else if (networkType === "google") {
    loginObj.scope = "basic,email";
  }

  let packageType = DEFAULT_SELF_SERVE_TRIAL_TYPE;

  if (type) {
    packageType = type;
  }

  if (!isLoginCall) {
    isLoginCall = true;
    service(
      {
        type: SOCIAL_TYPES[networkType],
        product: productType,
        package: packageType,
        couponCode,
        lifetimeCode,
      },
      isTeamLogin,
    )
      .done(success.bind(null, false))
      .fail(fail);
  }
}

export default login;
